import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Filter from './UI.AuthSelect.Filter';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Table, Row, Col, Button, Modal, Spin, message, Tooltip, Alert } from 'antd';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { history } from 'kts-platform-frame/routes';
import moment from 'moment';
import { invoiceManage, authManage } from 'src/api';
import InfiniteScroll from 'kts-scaffold-framework/component/InfiniteScroll';
import Template from 'kts-platform-frame/display/components/InvoiceTemplate';
import { AuthState, LoggingState, InvoiceState, DraftState } from './StateEnum';
import AuthFooter from './UI.Auth.Footer';
const { confirm } = Modal;
const { formatDate } = Field;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    random?: number;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))
export default class AuthSelect extends UIBasic<IProps, ModulesState> {
    state = {
        expand: false,
        templateType: '',
        template: false,
        templateData: null,
        hasMore: true,
        loading: false,
        taxPeriod: null,
        periodBegin: null,
        periodEnd: null,
        alerttype: null,
        selectedRowKeys: []
    };
    public scroller: InfiniteScroll;

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        this.getData();
        this.getTaxPeriod();
    }
    getTaxPeriod = () => {
        authManage.taxPeriod(this, {}).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                this.setState({
                    alerttype: 'warning',
                    taxPeriod: null
                });
                return null;
            } else {
                if (res) {
                    this.setState({
                        taxPeriod: res.taxPeriod.toString() + '01',
                        periodBegin: res.periodBegin,
                        periodEnd: res.periodEnd
                    });
                    let taxMonth = moment(res.taxPeriod.toString() + '01').month();
                    let taxYear = moment(res.taxPeriod.toString() + '01').year();
                    let month = moment().month();
                    let year = moment().year();
                    if (taxMonth !== month || taxYear !== year) {
                        this.setState({
                            alerttype: 'warning'
                        });
                    } else {
                        this.setState({
                            alerttype: 'info'
                        });
                    }
                } else {
                    this.setState({
                        alerttype: 'warning',
                        taxPeriod: null
                    });
                }
            }
        });
    }
    refreshPeriod = () => {
        authManage.taxPeriodRefresh(this, {}).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                if (res) {
                    this.setState({
                        taxPeriod: res.taxPeriod.toString() + '01',
                        periodBegin: res.periodBegin,
                        periodEnd: res.periodEnd
                    });
                    message.success("同步税期成功");
                    let taxMonth = moment(res.taxPeriod.toString() + '01').month();
                    let taxYear = moment(res.taxPeriod.toString() + '01').year();
                    let month = moment().month();
                    let year = moment().year();
                    if (taxMonth !== month || taxYear !== year) {
                        this.setState({
                            alerttype: 'warning'
                        });
                    } else {
                        this.setState({
                            alerttype: 'info'
                        });
                    }
                    ModulesAction.updateCount();
                } else {
                    message.warn('同步税期失败');
                    this.setState({
                        alerttype: 'warning',
                        taxPeriod: null
                    });
                }
            }
        });
    }
    componentWillReceiveProps(nextProps: any) {

    }
    getDueTime = time => {
        let { periodBegin } = this.state;
        if (!periodBegin) {
            return null;
        }
        const _date = new Date(time);
        // 开票时间
        const date =
            _date.getFullYear() +
            "-" +
            (_date.getMonth() + 1) +
            "-" +
            _date.getDate();
        // 声明当前日期
        const curr = moment();

        if (moment(periodBegin, 'YYYY-MM-DD').add(61, 'days').isAfter(date)) {
            const due = moment(periodBegin, "YYYY-MM-DD");
            let dueHours = moment(time).diff(moment(periodBegin), "hours");
            let dueTime = Math.floor((dueHours) / 24);
            return dueTime;
        }
    }
    isExpired = time => {
        let { periodBegin } = this.state;
        if (!periodBegin) {
            return false;
        }
        const _date = new Date(time);
        const date =
            _date.getFullYear() +
            "-" +
            (_date.getMonth() + 1) +
            "-" +
            _date.getDate();
        if (moment(periodBegin, 'YYYY-MM-DD').isAfter(date)) {
            return true;
        } else {
            return false;
        }
    }
    handleRefresh = () => {
        this.modulesState.selectInvoiceListData = [];
        this.modulesState.selectPageNumber = 1;
        this.modulesState.selectHasMore = true;
        this.modulesState.selectLoading = false;
        this.modulesState.draftedInvoiceId = [];
        ModulesAction.setModulesState().then(() => {
            this.getData();
        });

    }
    changePeriod = () => {
        confirm({
            title: '您确定切换税期吗？',
            onOk: () => {
                this.setState({
                    loading: true
                });
                authManage.changeTaxPeriod(this, null).then((response: any) => {
                    const err = response.er;
                    const res = response.res;
                    this.setState({
                        loading: false
                    });
                    if (!err) {
                        message.success("切换税期成功");
                        this.refreshPeriod();
                        this.setState({
                            alerttype: "info"
                        });
                    } else {
                        this.getTaxPeriod();
                        this.getData();

                    }
                });
            },
        });

    }
    clearState = () => {
        this.modulesState.selectInvoiceListData = [];
        this.modulesState.selectPageNumber = 1;
        this.modulesState.selectHasMore = true;
        this.modulesState.selectLoading = false;
        this.modulesState.draftedInvoiceId = [];
        ModulesAction.setModulesState();
    }
    componentWillUnmount() {
        this.clearState();
    }
    footerDom = () => {
        return (

            <div className='text-right'>
                <Button size="small" className="pull-left mr10" onClick={ModulesAction.onSelectAll}>全选</Button>
                <Button size="small" className="pull-left mr10" onClick={ModulesAction.onUnselectAll}>全部取消</Button>
                <div className='mr10' style={{ display: 'inline-block', marginRight: 50 }}>
                    <div className='bold_number'>
                        {Field.formatMoney(this.modulesState.draftedAmount, 2)}
                    </div>
                    <div>已勾选金额</div>
                </div>
                <div className='mr10' style={{ display: 'inline-block', marginRight: 50 }}>
                    <div className='bold_number'>
                        {Field.formatMoney(this.modulesState.draftedTax, 2)}
                    </div>
                    <div>已勾选税额</div>
                </div>
                <div className='mr10' style={{ display: 'inline-block' }}>
                    <div className='bold_number'> {this.modulesState.draftedLength}</div>
                    <div>已勾选发票张数</div>

                </div>
                <span onClick={() => { this.scroller.toTop(); }}>
                    <Button icon="huidaodingbuanniu" shape="circle" size='small' style={{ color: '#99A9BF' }} />
                </span>
            </div>
        );
    }
    //批量增加勾选数据
    addRows = (items) => {
        let { selectedRowKeys } = this.state;
        selectedRowKeys = [...selectedRowKeys, ...items];
        this.setState({
            selectedRowKeys
        });
        // this.modulesState.draftedInvoiceId=draftedInvoiceId;
        // ModulesAction.setModulesState();
    }
    //批量删除勾选数据
    removeRows = (items) => {
        let { selectedRowKeys } = this.state;
        let filterRows = selectedRowKeys.filter((item) => {
            let index = items.findIndex(element => {
                return element === item;
            });
            if (index < 0) {
                return item;
            }
        });
        // this.modulesState.draftedInvoiceId=filterRows;
        // ModulesAction.setModulesState();
        this.setState({
            selectedRowKeys: filterRows
        });
    }
    onComfirm = () => {
        if (this.state.selectedRowKeys.length > 0) {
            let keys = this.state.selectedRowKeys;
            let beside = this.modulesState.draftedInvoiceId;
            let filters = keys.filter(item => {
                return !beside.includes(item);
            });
            if (filters.length === 0) {
                message.error("没有可提交的数据");
            } else {
                ModulesAction.handleDraftInvoice(filters);
                this.setState({
                    selectedRowKeys: []
                });
            }
        } else {
            message.error("没有可提交的数据");
        }
    }

    render() {
        const columns = [
            {
                title: '发票代码',
                dataIndex: 'info',
                width: 100,
                render: (text, record) => (
                    <div>
                        {record.invoiceCode}
                        {
                            (record.authState !== 'PASS' && record.authState !== 'FAILED') &&
                                this.getDueTime(record.invoiceDate) < 61 &&
                                this.getDueTime(record.invoiceDate) > -1 ? (
                                    <span style={{ color: "red" }}>
                                        {" "}
                                        ({" "}
                                        {this.getDueTime(record.invoiceDate) ===
                                            0 ? (
                                                <span>今天到期</span>
                                            ) : (
                                                <span>
                                                    {this.getDueTime(
                                                        record.invoiceDate
                                                    )}{" "}
                                                    天后到期
                                                </span>
                                            )}{" "}
                                        )
                                    </span>
                                ) : null
                        }
                        {(record.authState !== 'PASS' || record.authState !== 'FAILED') && this.isExpired(record.invoiceDate) ? (
                            <span style={{ color: "red" }}>
                                {" "}
                                ( 已过期 )
                            </span>
                        ) : null}
                    </div>

                )
            },
            {
                title: '发票号码',
                dataIndex: 'invoiceNumber',
                width: 90,
            },
            {
                title: '销方名称',
                dataIndex: 'supplierName',
                className: css['nowrap'],
                render: text => {
                    return (<span title={text}>{text}</span>);
                }
            },
            {
                title: '开票日期',
                dataIndex: 'invoiceDate',
                width: 100,
                render: (text, record) => (
                    <span>{formatDate(record.invoiceDate)}</span>
                )
            },
            {
                title: '开票金额',
                dataIndex: 'amountWithoutTax',
                width: 100,
                render: (text, record) => (
                    <span>{Field.formatMoney(text, 2)}</span>
                )
            },
            {
                title: '税额',
                dataIndex: 'amountTax',
                width: 100,
                render: (text, record) => (
                    <span>{Field.formatMoney(text, 2)}</span>
                )
            },
            {
                title: '认证状态',
                dataIndex: 'authState',
                width: 90,
                render: (text, record) => (
                    <span>
                        {record.authState === 'FAILED' ?
                            <Tooltip title={record.authFailedReason} ><span>{AuthState[text]}</span></Tooltip> :
                            AuthState[text]}
                        {
                            record.authState === 'PASS' &&
                            (record.authType === 2 ? '(退)' : '(抵)')
                        }
                    </span>
                )
            },
            {
                title: '收票状态',
                width: 80,
                dataIndex: 'loggingState',
                render: (text) => (
                    <span>{LoggingState[text]}</span>
                )
            },
            {
                title: '发票状态',
                width: 80,
                dataIndex: 'invoiceState',
                render: (text) => (
                    <span>{InvoiceState[text]}</span>
                )
            },
            {
                title: '勾选状态',
                width: 80,
                dataIndex: 'draftState',
                render: (text) => (
                    <span>{DraftState[text]}</span>
                )
            },
            {
                title: '认证录入状态',
                width: 80,
                dataIndex: 'deductionInputState',
                render: (text) => (
                    <span>
                        {text === 1 ? '已录入' : '未录入'}
                    </span>
                )
            },
            {
                title: '勾选人',
                dataIndex: 'draftOperatorName',
                width: 65,
                render: (text, record) => (
                    <span>{text}</span>
                )
            },
            {
                title: '操作',
                dataIndex: 'a3',
                width: 70,
                render: (text, record) => (
                    <div>
                        {
                            //Lib.Util.UI.menuToggle(this.props.api, Lib.Util.Rule.GET_invoice_id_detail) &&
                            <span className="click-item" style={{ color: '#1A91EB' }} onClick={() => this.onDetail(record)} >
                                详情
                            </span>
                        }
                        {
                            //Lib.Util.UI.menuToggle(this.props.api, Lib.Util.Rule.GET_invoice_id_detail) &&
                            <span className="click-item hide" onClick={() => this.onShowTemplate(record)} >
                                票面信息
                            </span>
                        }
                        {record.imagePath && (
                            <span
                                className="click-item"
                                onClick={() => this.onPingzheng(record)}
                            >
                                <span className="vertical-line">|</span>
                                查看凭证
                            </span>
                        )}
                    </div>
                )
            }
        ];

        const { loadingUrls } = this.props;
        const { taxPeriod, periodBegin, periodEnd, alerttype, loading, selectedRowKeys } = this.state;
        const { user } = MyStore.instance.getState();
        const userId = user.userInfo.cUserId;
        const rowSelection = {
            onSelect: (record, selected) => {
                if (selected) {
                    this.addRows([record.incomeInvoiceBizId]);
                    //ModulesAction.handleDraftInvoice([record.incomeInvoiceBizId]);
                } else {
                    this.removeRows([record.incomeInvoiceBizId]);
                    //ModulesAction.handleUndraftInvoice([record.incomeInvoiceBizId]);
                }
            },
            onSelectAll: (selected, selectedRows, changeRows) => {
                const changedArray = changeRows.map(
                    item => item.incomeInvoiceBizId
                );
                if (selected) {
                    this.addRows(changedArray);
                    // ModulesAction.handleDraftInvoice(changedArray);
                } else {
                    this.removeRows(changedArray);
                    // ModulesAction.handleUndraftInvoice(changedArray);
                }
            },
            getCheckboxProps: record => ({
                //record.draftState === "DRAFT_COMMIT" || record.draftState === "DRAFT_PUSHED" // Column configuration not to be checked
                //过期不可选  已被勾选不可选  勾选人不是自己不可选
                disabled:
                    this.isExpired(record.invoiceDate) ||
                    (record.draftState === 'DRAFT_PUSHED' &&
                        record.draftOperator !== userId) ||
                    record.draftState === 'DRAFT_COMMIT'||
                    record.draftState === 'DRAFT_COMMIT_ING' ||
                    record.draftState === 'DRAFT_CANEL_ING' ||
                    record.authState === 'PASS' ||
                    record.authState === 'CHECKING' ||
                    record.authState === 'FAILED'


            }),
            selectedRowKeys: [...this.modulesState.draftedInvoiceId, ...selectedRowKeys]
        };
        return (
            <div style={{ height: 'calc(100% - 60px)' }}>
                <Row className={`${css['invoice-card-hander']}`}>
                    <Col span={12}>
                        <Button className="mr10" type="primary" onClick={() => { ModulesAction.showInvoiceInPanel(this.handleRefresh); }}>
                            发票勾选
                        </Button>
                        <Button className="mr10 hide" loading={loading} onClick={this.changePeriod} disabled={(alerttype === 'info' || !taxPeriod) ? true : false}>
                            切换税期
                        </Button>
                        <Button className="mr10" onClick={this.refreshPeriod}>
                            同步税期
                        </Button>
                        <Button className="mr10" onClick={this.onComfirm}>
                            确认提交
                        </Button>
                    </Col>

                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button onClick={this.toggleFilter} icon="filter">筛选</Button>
                        <Button className="ml10" icon="sync" onClick={this.handleRefresh}></Button>
                    </Col>
                </Row>
                <Row className={`${css['invoice-card-hander']}`}>
                    {
                        taxPeriod &&
                        <div className='mb10' style={{ overflow: 'hidden' }}>
                            <Col span={24}>
                                <Alert
                                    message={
                                        <span>
                                            <span className='mr10'>当前税款所属期：{moment(taxPeriod).format('YYYY年MM月')}</span>
                                            <span>
                                                当期可认证日期范围：{" "}
                                                {periodBegin && moment(periodBegin).format('YYYY 年 MM 月 DD 日')} ~{" "}
                                                {periodEnd && moment(periodEnd).format('YYYY 年 MM 月 DD 日')}{" "}
                                                {
                                                    alerttype === 'warning' &&
                                                    <span className="hide">
                                                        点击上方"切换税期"按钮可以切换至最新税款所属期
                                                    </span>
                                                }
                                            </span>
                                        </span>
                                    }
                                    type={alerttype}
                                    showIcon={true}
                                />
                            </Col>
                        </div>
                    }
                    {
                        !taxPeriod &&
                        <div className='mb10' style={{ overflow: 'hidden' }}>
                            <Col span={24}>
                                <Alert
                                    message={
                                        <span>
                                            <span className='mr10'>当前税期未知，请点击上方“同步税期”按钮获取税期信息后再进行业务操作。</span>
                                        </span>
                                    }
                                    type={alerttype}
                                    showIcon={true}
                                />
                            </Col>
                        </div>
                    }
                </Row>
                <Spin spinning={loadingUrls.size > 0}>
                    <div style={{ height: 'calc(100Vh - 174px)', overflow: 'auto' }}>
                        <InfiniteScroll
                            loadMore={this.getData}
                            hasMore={!this.modulesState.selectLoading && this.modulesState.selectHasMore}
                            ref={(target) => { this.scroller = target; }}
                        >
                            <Table
                                rowKey="incomeInvoiceBizId"
                                columns={columns}
                                dataSource={this.modulesState.selectInvoiceListData}
                                rowSelection={rowSelection}
                                pagination={false}
                                bordered={true}
                                scroll={{ y: 'calc(100Vh - 281px)' }}
                            />
                        </InfiniteScroll>
                    </div>
                </Spin>
                {
                    this.state.template &&
                    Template({ type: this.state.templateType, data: this.state.templateData, onClose: this.closeTemplate })
                }
            </div>
        );
    }
    private toggleFilter = () => {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <Filter />,
            title: '筛选'
        });
    }
    private getData = () => {
        if (this.modulesState.selectHasMore) {
            this.modulesState.selectLoading = true;
            ModulesAction.setModulesState();
            const { user } = MyStore.instance.getState();
            const companyId = user.userInfo.companyId;
            ModulesAction.updateSelect({
                companyId,
                pageNum: this.modulesState.selectPageNumber,
                pageSize: this.modulesState.selectPageSize,
                ...this.modulesState.selectFields
            }, null, this.setRowKeys);
            ModulesAction.updateCount();
        }
    }
    setRowKeys = (items) => {
        const { user } = MyStore.instance.getState();
        const userId = user.userInfo.cUserId;
        const _draftedInvoiceId = items
            .filter(item => { return ((item.draftState === 'DRAFT_COMMIT')); })
            .map(item => item.incomeInvoiceBizId);
        this.setState({
            selectedRowKeys: Array.from(new Set(this.modulesState.draftedInvoiceId.concat(_draftedInvoiceId)))
        });
    }
    private onDetail = (record) => {
        let params = {
            incomeInvoiceBizId: record.incomeInvoiceBizId
        };
        authManage.getInvoiceDetail(this, params).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                // message.error(err.status.description);
                return null;
            } else {
                var data = { invoiceDetail: response.res, realCheckTime: null };
                var path = {
                    pathname: `invoiceDetail/${record.incomeInvoiceBizId}`,
                    state: data,
                };
                history.push(path);
            }
        });
    }
    private onShowTemplate = record => {
        let data = {
            incomeInvoiceBizId: record.incomeInvoiceBizId
        };
        invoiceManage.getInvoiceByBizId(this, data).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        template: true,
                        templateData: res,
                        templateType: record.invoiceType
                    });
                }
            }
        });
    }
    private onPingzheng(a: string) {
        console.log(a);
    }
    private closeTemplate = () => {
        this.setState({
            template: false
        });
    }
    private getDateRange() {
        let dateStart;
        if (moment().isAfter('2018-06-26')) {
            dateStart = moment()
                .subtract(360, "days")
                .format("YYYY 年 MM 月 DD 日");
        } else {
            dateStart = "2017 年 07 月 01 日";

        }
        return {
            dateStart: dateStart,
            dateEnd:
                moment().format("YYYY 年 MM 月 DD 日")
        };
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthSelect.tsx